<template>
  <form id="frm_action">
    <div class="p-formgrid">
<!--      <div class="p-card-field1">-->
<!--        <div class="p-field p-grid">-->
<!--          <label class="p-col-fixed "><strong>Tiêu đề</strong><span style="color: red ; padding-left: 1px">*</span></label>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="p-card-field1">-->
<!--        <div class="p-field p-grid">-->
<!--          <InputText required v-model="title" type="text" id="name_add" class="p-col-width1" placeholder="Nhập tiêu đề"/>-->
<!--        </div>-->
<!--      </div>-->

      <div class="p-card-field1">
        <div class="p-field p-grid">
          <label class="p-col-fixed "><strong>Information (EN) </strong><span style="color: red ; padding-left: 1px"> *</span></label>
        </div>
      </div>
      <div class="p-card-field1">
        <div class="p-field p-grid">
          <input class="input_tmp_validator" id="validator_content_en">
          <CkeditorCode :key="content_key" :contentSet="content_en" @newdata="handleDataCkditor_en($event,'content_en')"></CkeditorCode>
        </div>
      </div>
      <div class="p-card-field1">
        <div class="p-field p-grid">
          <label class="p-col-fixed "><strong>Information (KR) </strong><span style="color: red ; padding-left: 1px"> *</span></label>
        </div>
      </div>
      <div class="p-card-field1">
        <div class="p-field p-grid">
          <input class="input_tmp_validator" id="validator_content_ko">
          <CkeditorCode :key="content_key" :contentSet="content_ko" @newdata="handleDataCkditor_ko($event,'content_ko')"></CkeditorCode>
        </div>
      </div>
      <div class="p-card-field1">
        <div class="p-field p-grid">
          <label class="p-col-fixed "><strong>Information (VN) </strong><span style="color: red ; padding-left: 1px"> *</span></label>
        </div>
      </div>
      <div class="p-card-field1">
        <div class="p-field p-grid">
          <input class="input_tmp_validator" id="validator_content_vi">
          <CkeditorCode :key="content_key" :contentSet="content_vi" @newdata="handleDataCkditor_vi($event,'content_vi')"></CkeditorCode>
        </div>
      </div>


      <Toolbar class="fixed-bottom-toolbar">
        <template slot="right">
<!--          <Button-->
<!--              label="Quay lại"-->
<!--              @click="backToList()"-->
<!--              class="p-button-warning"-->
<!--              style="width: 120px !important;"-->
<!--          />-->
          <Button
              v-if="mode == 'edit'"
              :label="'Save'"
              @click="saveData()"
              class="p-button-success save"
              style="width: 120px !important;"

          />
          <!-- <Button
            v-else
            :label="'Tạo'"
            @click="saveData()"
            class="p-button-success"
            style="width: 120px !important;"

          /> -->
        </template>
      </Toolbar>
    </div>
  </form>
</template>

<script>
import DataServices from '@/core/DataServices'
import CkeditorCode from '../CkeditorCode';
export default {
  components: {
    CkeditorCode
  },
  props: {
    mode: String,
    model: Object,
    users: Array
  },
  data() {
    return {
      policy_content:'',
      content_key:0,
      content_en: '',
      content_ko: '',
      content_vi: '',
      title: '',
      ordinal: 1,
      validationErrors: {},
      formMode: this.mode,
      firebaseID: null,
      userID: null,
      role: {
        view: false,
        add: false,
        edit: false,
        delete: false,
      },
      images: [],
      imagesDeletes: [],
      imgDelete : [],
      maxFileSize: 1000000, // 1MB
      maxFiles: 1,
      saving:false,
    }
  },
  async mounted() {
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      console.log("this.model*****************",this.model)
      var policy_id = this.model.id

      var gqLQueryList = DataServices.getList('policy_lang');
      console.log("gqL",gqLQueryList)
      var resData = await this.$apollo.mutate({
        mutation: gqLQueryList,
        variables: {
          where_key: {policy_id :{_eq: policy_id}},
        }
      });

      var listData = resData.data['policy_lang'];
      console.log("listData",listData)

      for (var i = 0 ; i < listData.length ; i++){
        if (listData[i].lang == "en"){
          this.content_en = listData[i].infomation
        }
        else if (listData[i].lang == "ko"){
          this.content_ko = listData[i].infomation
        }
        else if (listData[i].lang == "vi"){
          this.content_vi = listData[i].infomation
        }
      }
      console.log("wqwqwqwqw",this.content_en,this.content_ko,this.content_vi)
this.content_key++;


    }
    var arr_role = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.EDIT_POLICY);
    this.role.edit = (arr_role.indexOf(this.$constants.ROLE.EDIT) < 0) ? false:true;

    // var that =this;
    //   if(this.model.relationship_file && this.model.relationship_file.length > 0){
    //     for (let i = 0; i < this.model.relationship_file.length; i++) {
    //       const e = this.model.relationship_file[i];
    //       if(e.type == 'POLICY'){
    //         if (e.file && e.file.url) {
    //           let url = e.file.url
    //           let split = url.split('/')
    //           let fileName = split[split.length - 1]
    //           let obj = {'name': fileName, 'file': '', 'objectURL': url,type:'old_edit'}//type:'old_edit' nếu gặp type này ko update avatar
    //           this.images.push(obj)
    //         }
    //       }
    //     }
    //   }

  },
  methods: {
    handleDataCkditor_en: function(e,key) {
      var dataContent = (e.length) ? e[0]:'';
      if (key == 'content_en'){
        this.content_en = dataContent;
      }
      console.log("content_en",this.content_en)
    }
    ,
    handleDataCkditor_ko: function(e,key) {
      var dataContent = (e.length) ? e[0]:'';
      if (key == 'content_ko'){
        this.content_ko = dataContent;
      }
      console.log("content_ko",this.content_ko)
    }
    ,
    handleDataCkditor_vi: function(e,key) {
      var dataContent = (e.length) ? e[0]:'';
      if (key == 'content_vi'){
        this.content_vi = dataContent;
      }
      console.log("content_vi",this.content_vi)
    }
    ,
    backToList() {
      this.$emit('back');
    },
    async validateData() {
      this.validationErrors = {};
      console.log("uiqwqwqwq",this.content_en)
      if (this.$commonFuction.isEmpty(this.content_en)) {
        console.log("content_en",this.content_en)
        document.getElementById("validator_content_en").setCustomValidity("Please enter the content");
      }
      else {
        document.getElementById("validator_content_en").setCustomValidity("");
      }
       if (this.$commonFuction.isEmpty(this.content_ko)) {
        console.log("content_korea",this.content_ko)
        document.getElementById("validator_content_ko").setCustomValidity("Please enter the content");
      }
       else {
         document.getElementById("validator_content_ko").setCustomValidity("");
       }
       if (this.$commonFuction.isEmpty(this.content_vi)) {
        console.log("content_vi",this.content_vi)
        document.getElementById("validator_content_vi").setCustomValidity("Please enter the content");
      }
       else {
         document.getElementById("validator_content_vi").setCustomValidity("");
       }

      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()){
        console.log('test=====================');
        inpObj.reportValidity();
        return true;
      }
    },
    async saveData() {
      // this.$commonFuction.is_loading(true);
       if (await this.validateData()) {
         console.log("iwiewiewwe")
        // this.saving = false;
       // this.$commonFuction.is_loading(false);
        return
      }
      if(Object.entries(this.validationErrors).length === 0){
        var params = {
          content_en: this.content_en,
          content_ko: this.content_ko,
          content_vi: this.content_vi,
        }
        console.log("savedata",params)
        this.$emit('save', params);
      }
      else{
        this.$commonFuction.is_loading(false);
      }
    }, 
    isImage(file) {
      return /^image\//.test(file.type);
    },
    async onFileSelect(event) {
      let files = event.target.files || event.dataTransfer.files;
      if(files.length > 0) {
        let acceptTags = ['jpeg', 'jpg', 'gif', 'png', 'JPEG', 'JPG', 'PNG', 'GIF']
        for (let i = 0; i < files.length; i++) {
          if (!acceptTags.includes(files[i].name.split('.').pop())) {
            alert("Vui lòng upload file ảnh có định dạng sau: jpeg, jpg, gif, png");
            return;
          }
        }
        if (files.length + this.images.length > this.maxFiles) {
          alert("Hình ảnh quá số lượng tối đa là " + this.maxFiles + " hình");
        } else {
          var arrTemp = [], arrFiles = [];
          for (let file of files) {
            if (this.isImage(file) && file.size <= this.maxFileSize) {
              file.source = file;
              file.objectURL = window.URL.createObjectURL(file);
              arrTemp.push(file);
            }
            if (file.size > this.maxFileSize) arrFiles.push(file);
          }
          
          if (arrFiles.length > 0) {
            alert("Hình ảnh của bạn đã quá dung lượng 1MB");
          } else {
            if (this.images.length > 0 && this.images[0].file === '') {
              this.imagesDeletes.push(this.images[0])
            }
            // this.images = [];
            this.images = this.images.concat.apply(this.images, arrTemp);
            // console.log(this.images)
            // await this.validateData()
          }
        }
      }
    },
    onFileClear(index) {
      let img = this.images[index];
      this.images.splice(index, 1);
      if (img.file === '') {
        this.imgDelete.push(img)
      }
    }
  },
  apollo: {
    
  }
}
</script>

<style lang="scss">
  .p-invalid {
    color: red;
    margin: 1px 0px 0px 0px;
  }
  .p-multiselect {
    width: 450px;
  }
  .p-multiselect-label:not(.p-placeholder) {
    padding-top: .25rem;
    padding-bottom: .25rem;
    
  }
  .category-item-value {
    padding: .25rem .5rem;
    border-radius: 3px;
    display: inline-flex;
    margin-right: .2rem;
    background-color: var(--primary-color);
    color: var(--primary-color-text);
  }
  .p-multiselect-label-container{
    height: 40px;
  }
  .p-invalid {
    color: red;
    margin: 1px 0px 0px 0px;
  }
  .text-active{
    margin: 0px 0px 0px 8px;
  }
  .p-formgrid >.p-card-field1 >.p-field >.p-col-width1 >.p-dropdown-panel{
    left : 0px !important
  }
  .p-col-width1 {
    width: 100%;
  }

  .save{
    background-color: #E73725!important;
    border: 1px solid #E73725!important;
  }
  .p-field{
    margin-bottom: 0px!important;
  }
  .p-col-fixed{
    margin-top: 12px!important;
    padding: 0px!important;
  }

  </style>
